import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/shared/api/client';
import type { Platform } from '@/shared/constants';

export const infoMessageSchema = z
  .object({
    isEnabled: z.boolean().optional(),
    displayOn: z.string().optional(),
    message: z.string().optional(),
    level: z.enum(['red', 'orange', 'green', 'grey']).optional(),
    threadFilterEnabled: z.boolean().optional(),
    platform: z.string().optional(),
    error: z.unknown().optional(),
  })

  .nullable();

export type InfoMessage = z.infer<typeof infoMessageSchema>;

export const fetchInfoMessage = (platform: Platform) =>
  api.get<InfoMessage>('config/info', {
    query: { platform },
    schema: infoMessageSchema,
  });

export const infoMessageQueryOptions = (platform: Platform) =>
  queryOptions({
    queryKey: ['info-message', platform] as const,
    queryFn: () => fetchInfoMessage(platform),
    staleTime: 30_000,
    retry: false,
  });

/** The banner is shown only when enabled and targeted at the back office. */
export const isDisplayedOnBackOffice = (
  info: InfoMessage | undefined,
): info is NonNullable<InfoMessage> =>
  !!info &&
  !info.error &&
  info.isEnabled === true &&
  ['all', 'bo'].includes(info.displayOn ?? '');
